import { TabPane, Tabs } from '@/components/Tabs'
import { AssetTabs } from '@/hooks/components/use-asset-fund-asset-list-component'
import { CustomTableLayout } from '@/layouts/CustomTableLayout'
import { APP_CONFIG, AssetType } from '@/project-config'
import { ElSkeleton, ElSkeletonItem, ElTableColumn } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useLanguageStore } from 'store'
import { HocElTable } from 'ui-components'
import './AssetListSkeleton.scss'

export const AssetListSkeleton = defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rowCount: {
      type: Number,
      default: 10,
    },
  },
  setup(props, { slots }) {
    const { t } = useI18n()
    const languageStore = useLanguageStore()
    const commonSkeleton = () => (
      <ElSkeleton animated loading>
        {{
          template: () => <ElSkeletonItem class="common-skeleton-item" variant={'rect'} />,
        }}
      </ElSkeleton>
    )

    return () => {
      if (props.loading) {
        return (
          <CustomTableLayout>
            <div class="asset-list-skeleton-layout">
              <Tabs tabHeight={54} showDivider={false} tabNavHeight={40} class={'primary-tabs'} modelValue={AssetType.Digital}>
                {AssetTabs.map((tab) => {
                  return <TabPane name={tab.type} label={t(tab.title)}></TabPane>
                })}
              </Tabs>
              <HocElTable data={Array.from({ length: props.rowCount }).fill({})}>
                <ElTableColumn label="币种" sortable>
                  <div class="coin-skeleton">
                    <ElSkeleton animated loading>
                      {{
                        template: () => (
                          <>
                            <ElSkeletonItem class={'avatar-skeleton'} variant={'circle'} />
                            <ElSkeletonItem class={'name-skeleton'} variant={'rect'} />
                          </>
                        ),
                      }}
                    </ElSkeleton>
                  </div>
                </ElTableColumn>
                <ElTableColumn label="全部" sortable>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>
                <ElTableColumn label="可用" sortable>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>
                <ElTableColumn label="冻结" sortable>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>
                <ElTableColumn label="估值" sortable>
                  {{
                    default: () => commonSkeleton(),
                  }}
                </ElTableColumn>
                <ElTableColumn label="操作" width={languageStore.isZH ? 120 : 'auto'}>
                  {{
                    default: () => (
                      <div class="btn-skeleton">
                        {commonSkeleton()}
                        {commonSkeleton()}
                        {APP_CONFIG.isExchange && commonSkeleton()}
                      </div>
                    ),
                  }}
                </ElTableColumn>
              </HocElTable>
            </div>
          </CustomTableLayout>
        )
      }

      return slots.default?.()
    }
  },
})
